import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  variant?: 'green' | 'terracotta';
}
export function CTAButton({
  children,
  onClick,
  href,
  className = '',
  variant = 'green'
}: CTAButtonProps) {
  const base = 'inline-block text-center rounded-full font-bold uppercase tracking-wide text-white px-8 py-4 text-sm md:text-base shadow-md transition-[transform,box-shadow,background-color] duration-150 ease-smooth hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-brand-green';
  const variants = {
    green: 'bg-brand-green hover:bg-brand-greenDark',
    terracotta: 'bg-brand-terracotta hover:bg-brand-terracottaDark focus-visible:ring-white'
  };
  const classes = `${base} ${variants[variant]} ${className}`;
  if (href) {
    return <a href={href} onClick={onClick} className={classes} data-id="element-37" data-mp="38pttf8vrr1dk">
        {children}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} data-id="element-38" data-mp="19apraooau2cl">
      {children}
    </button>;
}